 $(document).ready(function(){

        $('.testimonials-slider').slick({
         slidesToShow: 1,
         slidesToScroll: 1,
         arrows: true,
         fade: true,
         asNavFor: '.testimonials-slider-nav'
       });
      $('.testimonials-slider-nav').slick({
          slidesToShow: 5, // Display only 5 slides
          slidesToScroll: 1,
          asNavFor: '.testimonials-slider',
          dots: false,
          arrows: false,
          focusOnSelect: true,
          centerMode: true,
          infinite: true,
       
          responsive: [
              {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 3,
                      centerMode: true,
                      slidesToScroll: 1
                  }
              }
          ],
        variableWidth: false, 
          centerPadding: '10px' 
      });
       

        $('.meet-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        });
        $('.news_slider').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
         autoplay:true,
          useTransform: false,
         responsive: [
            {
              breakpoint: 768,
              settings: {
              slidesToShow: 1,
              swipe: true,
                dots: true,
                  arrows: false,
              slidesToScroll: 1
              }
            }
          ]
        });
     $('.video_testi_slider').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
         
         adaptiveHeight: true,
         responsive: [
                   {
                    breakpoint: 1024, 
                    settings: {
                        slidesToShow: 2, 
                        slidesToScroll: 1,
                       arrows: true,
                        swipe: true
                    }
                },
                {
                    breakpoint: 768, // Mobile breakpoint
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        swipe: true
                    }
                }
            
          ]
        });
        $('.find-slider').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          autoplay:true,
           autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 768,
              settings: {
              slidesToShow: 2,
              swipe: true,
              centerMode: false, 
              slidesToScroll: 1
              }
            }
          ]
        });

     $('.logo-slider').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: false,         
          autoplay:true,
           autoplaySpeed: 2000,
          infinite: true,
          responsive: [
             {
                    breakpoint: 1024, 
                    settings: {
                        slidesToShow: 3,                         
                        swipe: true
                    }
                },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                swipe: true,         
              }
            }
          ]
        });
  $(".toggle_btn").click(function() {
    
    $(".toggle_content").slideToggle();
    $(this).text(function(i, text){
            return text === "VIEW MORE →" ? "VIEW LESS →" : "VIEW MORE →";
        });
   
});

        document.getElementById('playButton').addEventListener('click', function() {
          var video = document.getElementById('tylerVideo');
          if (video.paused) {
            video.play();
            this.style.display = 'none'; // Hide play button when video is playing
          } else {
            video.pause();
          }
        });

        // Show/hide play button based on video state
        document.getElementById('tylerVideo').addEventListener('play', function() {
          document.getElementById('playButton').style.display = 'none';
        });

        document.getElementById('tylerVideo').addEventListener('pause', function() {
          document.getElementById('playButton').style.display = 'block';
        });

      });